<template>
  <div class="auth_mall_select">
    <a-select
      ref="select"
      v-model:value="value"
      style="width: 170px"
      placeholder="请选择 1 个店铺"
      @change="changeMall"
    >
      <a-select-option v-for="item in list" :value="item.ShopId" :key="item.ShopId">
        {{ item.auth?.ShopName }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import handler from './handler'
import { mapGetters} from 'vuex'
import { Modal } from 'ant-design-vue'
import { Service_GetPddMoveInfo,Service_SetPddMoveInfo } from '@/service/auth_mall_service'
import { Service_GetBranchRelId } from '@/service/branch_relId_service'
export default {
  data() {
    return {
      list:[],
      value:'',
      isInit: false
    }
  },
    computed:{
    ...mapGetters({
      GroupId: 'mall_group/GroupId'
    }),
  },
  methods:{
    async getAuthMallList() {
      if(!this.GroupId) return
      this.list = await handler.GetMallList(this.GroupId)
      var currentMall= Service_GetPddMoveInfo()
      this.value = currentMall?.ShopId || null
      // 查看该店铺是否授权了应用(晓风分销...)
      var branchRelId = Service_GetBranchRelId(currentMall)
      if(!branchRelId) {
        return Modal.warning({
          title: '温馨提示',
          content: `店铺未添加应用, 请前往添加!`,
          okText: '去添加店铺',
          onOk: () => this.$router.push('/home/mallGroup')
        })
      }
      
      this.$emit('get-success', this.value ? true : false) 
    },
    changeMall() {
      const item = this.list.find(item => item.ShopId === this.value)
      if (item) {
        Service_SetPddMoveInfo(item)
        this.$message.success('上货店铺切换成功')
        this.$emit('get-success', true)
      }
    },
  },
  watch:{
    GroupId: {
      handler() {
        this.getAuthMallList()
      },
      immediate: true,
    },
  },
}
</script>

<style lang='less' scoped>

</style>